import { useQuery, useMutation } from 'react-query'
import axios from 'axios'

const ENDPOINT = `/api/application`
const QUERY_KEY = 'application'

export const usePostApplication = (config = {}) =>
  useMutation((data) => axios.post(`${ENDPOINT}/create-application`, data), config)

export const useGetCount = (config = {}) =>
  useQuery(
    [QUERY_KEY, 'detail', 'count'],
    async () => (await axios.get(`${ENDPOINT}/count`))?.data,
    config
  )
